export function featureServiceUnsupported(optional, providerId, consumerId, versionRange, supportedVersions) {
    return `The ${optional ? 'optional' : 'required'} Feature Service ${JSON.stringify(providerId)} in the unsupported version range ${JSON.stringify(versionRange)} could not be bound to consumer ${JSON.stringify(consumerId)}. The supported versions are ${JSON.stringify(supportedVersions)}.`;
}
export function featureServiceVersionInvalid(providerId, registrantId, version) {
    return `The Feature Service ${JSON.stringify(providerId)} could not be registered by registrant ${JSON.stringify(registrantId)} because it defines the invalid version ${JSON.stringify(version)}.`;
}
export function featureServiceDependencyVersionInvalid(optional, providerId, consumerId) {
    return `The ${optional ? 'optional' : 'required'} Feature Service ${JSON.stringify(providerId)} in an invalid version could not be bound to consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServiceNotRegistered(optional, providerId, consumerId) {
    return `The ${optional ? 'optional' : 'required'} Feature Service ${JSON.stringify(providerId)} is not registered and therefore could not be bound to consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServiceReturnedUndefined(providerId, registrantId) {
    return `The Feature Service ${JSON.stringify(providerId)} could not be registered by registrant ${JSON.stringify(registrantId)} because it returned undefined.`;
}
export function featureServiceSuccessfullyRegistered(providerId, registrantId) {
    return `The Feature Service ${JSON.stringify(providerId)} has been successfully registered by registrant ${JSON.stringify(registrantId)}.`;
}
export function featureServiceAlreadyRegistered(providerId, registrantId) {
    return `The already registered Feature Service ${JSON.stringify(providerId)} could not be re-registered by registrant ${JSON.stringify(registrantId)}.`;
}
export function featureServiceSuccessfullyBound(providerId, consumerId) {
    return `The required Feature Service ${JSON.stringify(providerId)} has been successfully bound to consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServicesAlreadyBound(consumerId) {
    return `All required Feature Services are already bound to consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServiceCouldNotBeUnbound(providerId, consumerId) {
    return `The required Feature Service ${JSON.stringify(providerId)} could not be unbound from consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServiceSuccessfullyUnbound(providerId, consumerId) {
    return `The required Feature Service ${JSON.stringify(providerId)} has been successfully unbound from consumer ${JSON.stringify(consumerId)}.`;
}
export function featureServicesAlreadyUnbound(consumerId) {
    return `All required Feature Services are already unbound from consumer ${JSON.stringify(consumerId)}.`;
}
//# sourceMappingURL=feature-service-registry-messages.js.map